module.exports = __webpack_public_path__ + "img/zfb.a99227ee.png";